import { NavLink, Outlet } from "react-router";
import { BadgeCheck, BarChart3, Briefcase, Flag, Home, LayoutDashboard, LogOut, Timer, Users } from "lucide-react";
import { Button, cx } from "@fellowflats/ui";
import { useAuth } from "../lib/auth";
import { Brand } from "./brand";

const NAV = [
  { to: "/", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/listings", label: "Listings", icon: Home },
  { to: "/verifications", label: "Verifications", icon: BadgeCheck },
  { to: "/reports", label: "Reports", icon: Flag },
  { to: "/people", label: "People", icon: Users },
  { to: "/leads", label: "Leads", icon: Briefcase },
  { to: "/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/jobs", label: "Jobs", icon: Timer },
];

export function Layout() {
  const { session, signOut } = useAuth();
  return (
    <div className="min-h-screen md:grid md:grid-cols-[220px_1fr]">
      <aside className="border-b border-border bg-muted/60 p-4 md:min-h-screen md:border-b-0 md:border-r">
        <Brand />
        <nav className="mt-6 flex gap-1 overflow-x-auto md:flex-col" aria-label="Admin">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                cx(
                  "flex items-center gap-2 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors",
                  isActive ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:bg-background hover:text-foreground",
                )
              }
            >
              <Icon size={16} aria-hidden="true" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-6 hidden border-t border-border pt-4 md:block">
          <p className="truncate text-xs text-muted-foreground">{session?.user.email}</p>
          <Button variant="ghost" size="sm" className="mt-2 -ml-3" onClick={() => void signOut()}>
            <LogOut size={14} aria-hidden="true" /> Sign out
          </Button>
        </div>
      </aside>
      <main className="mx-auto w-full max-w-5xl px-4 py-8 md:px-8">
        <Outlet />
      </main>
    </div>
  );
}
